// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2KWad","insightsList":"newBusinessInsightsMenu_insightsList__11ln1","active":"newBusinessInsightsMenu_active__1HU7f"};